import React, { useMemo } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const DEFAULT_TOOLBAR = [
  "heading",
  "|",
  "bold",
  "italic",
  "underline",
  "strikethrough",
  "|",
  "bulletedList",
  "numberedList",
  "|",
  "outdent",
  "indent",
  "|",
  "blockQuote",
  "insertTable",
  "|",
  "undo",
  "redo",
];

const CommonRichTextEditor = ({
  value = "",
  onChange,
  disabled = false,
  placeholder,
  editorKey,
  minHeight = 200,
  onReady,
}) => {
  const config = useMemo(
    () => ({
      toolbar: DEFAULT_TOOLBAR,
      ...(placeholder ? { placeholder } : {}),
    }),
    [placeholder]
  );

  return (
    <div style={{ minHeight: `${minHeight}px` }}>
      <CKEditor
        key={editorKey}
        editor={ClassicEditor}
        config={config}
        data={value || ""}
        onReady={(editor) => {
          if (disabled) {
            editor.enableReadOnlyMode("common-rich-text-disabled");
          }
          const content = value || "";
          if (content && editor.getData() !== content) {
            editor.setData(content);
          }
          onReady?.(editor);
        }}
        onChange={(event, editor) => {
          if (!disabled) {
            onChange?.(editor.getData());
          }
        }}
      />
    </div>
  );
};

export default CommonRichTextEditor;
